import { decodeAuthTokenClaims } from '@up2rent/graphql';
import isNil from 'lodash/isNil';

const readTokenClientId = (token: string): string | null => decodeAuthTokenClaims(token)?.clientId ?? null;

export const isStaleScopeDenial = (
  deniedToken: string | null,
  freshToken: string | null,
  activeOrganizationId: string | null
): boolean => {
  if (isNil(deniedToken) || isNil(freshToken) || isNil(activeOrganizationId)) {
    return false;
  }
  return (
    readTokenClientId(deniedToken) !== activeOrganizationId && readTokenClientId(freshToken) === activeOrganizationId
  );
};

export const isExpiredTokenDenial = (deniedToken: string | null, freshToken: string | null): boolean => {
  const deniedExpiresAt = decodeAuthTokenClaims(deniedToken)?.exp;
  const freshIssuedAt = decodeAuthTokenClaims(freshToken)?.iat;
  if (isNil(deniedExpiresAt) || isNil(freshIssuedAt)) {
    return false;
  }
  return freshIssuedAt >= deniedExpiresAt;
};

export enum AuthDenialOutcome {
  REVOKED = 'REVOKED',
  STALE_TOKEN = 'STALE_TOKEN',
  UNCONFIRMED = 'UNCONFIRMED',
}

export const getAuthDenialOutcome = (
  deniedToken: string | null,
  freshToken: string | null,
  activeOrganizationId: string | null
): AuthDenialOutcome => {
  if (isNil(deniedToken) || isNil(freshToken)) {
    return AuthDenialOutcome.UNCONFIRMED;
  }
  if (
    isStaleScopeDenial(deniedToken, freshToken, activeOrganizationId) ||
    isExpiredTokenDenial(deniedToken, freshToken)
  ) {
    return AuthDenialOutcome.STALE_TOKEN;
  }
  return AuthDenialOutcome.REVOKED;
};
